import { render, staticRenderFns } from "./CadastreInput.vue?vue&type=template&id=20b28a18&scoped=true&"
import script from "./CadastreInput.vue?vue&type=script&lang=js&"
export * from "./CadastreInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b28a18",
  null
  
)

export default component.exports